import React from 'react';

type Props = {
  width?: string,
  height?: string,
  fill?: string,
  className: string,
}

const Group = ({ className, fill, width, height }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 26.751 18.397"
    className={className}
    transform="scale(1.2)"
  >
    <g id="Group_439" dataname="Group 439" transform="translate(-138.789 -452.539)">
      <g id="Group_307" dataname="Group 307" transform="translate(0 -921.173)">
        <path
          id="Path_636"
          dataname="Path 636"
          d="M159.013,1392.109a.5.5,0,0,1-.5-.5,6.376,6.376,0,1,0-12.723,0,.5.5,0,0,1-1,0,7.375,7.375,0,1,1,14.723,0A.5.5,0,0,1,159.013,1392.109Z"
          fill={fill}
        />
      </g>
      <g id="Group_308" dataname="Group 308" transform="translate(0 -921.173)">
        <path
          id="Path_637"
          dataname="Path 637"
          d="M152.406,1382.77a4.529,4.529,0,1,1,4.53-4.529A4.535,4.535,0,0,1,152.406,1382.77Zm0-8.058a3.529,3.529,0,1,0,3.53,3.529A3.533,3.533,0,0,0,152.406,1374.712Z"
          fill={fill}
        />
      </g>
      <g id="Group_309" dataname="Group 309" transform="translate(0 -921.173)">
        <path
          id="Path_638"
          dataname="Path 638"
          d="M146.445,1385.546a.5.5,0,0,1-.5-.5,3.086,3.086,0,1,0-6.156,0,.5.5,0,0,1-1,0,4.084,4.084,0,1,1,8.156,0A.5.5,0,0,1,146.445,1385.546Z"
          fill={fill}
        />
      </g>
      <g id="Group_310" dataname="Group 310" transform="translate(0 -921.173)">
        <path
          id="Path_639"
          dataname="Path 639"
          d="M143,1380.675a2.6,2.6,0,1,1,2.6-2.6A2.6,2.6,0,0,1,143,1380.675Zm0-4.2a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,143,1376.472Z"
          fill={fill}
        />
      </g>
      <g id="Group_311" dataname="Group 311" transform="translate(0 -921.173)">
        <path
          id="Path_640"
          dataname="Path 640"
          d="M165.04,1385.546a.5.5,0,0,1-.5-.5,3.087,3.087,0,1,0-6.157,0,.5.5,0,0,1-1,0,4.085,4.085,0,1,1,8.157,0A.5.5,0,0,1,165.04,1385.546Z"
          fill={fill}
        />
      </g>
      <g id="Group_312" dataname="Group 312" transform="translate(0 -921.173)">
        <path
          id="Path_641"
          dataname="Path 641"
          d="M161.6,1380.675a2.6,2.6,0,1,1,2.6-2.6A2.6,2.6,0,0,1,161.6,1380.675Zm0-4.2a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,161.6,1376.472Z"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

Group.defaultProps = {
  fill: '#1a1818',
  width: '26.751',
  height: '18.397',
};

export default Group;
